import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost, apiDelete } from "../../lib/api";

type DistributionList = {
  id: number;
  name: string;
  description: string | null;
  member_count: number;
  created_at: string;
};

export default function AdminLists() {
  const qc = useQueryClient();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["lists"],
    queryFn: () => apiGet<{ items: DistributionList[] }>("/api/admin/lists"),
  });

  const createMutation = useMutation({
    mutationFn: () => apiPost("/api/admin/lists", { name, description }),
    onSuccess: () => {
      setName("");
      setDescription("");
      void qc.invalidateQueries({ queryKey: ["lists"] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: number) => apiDelete(`/api/admin/lists/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["lists"] }),
  });

  return (
    <div>
      <h1>Distribuční seznamy</h1>

      <div className="card" style={{ marginBottom: 24 }}>
        <h3>Vytvořit nový seznam</h3>
        <div className="field">
          <label htmlFor="ln">Název</label>
          <input id="ln" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="ld">Popis (volitelné)</label>
          <input id="ld" value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>
        <button
          type="button"
          disabled={!name || createMutation.isPending}
          onClick={() => createMutation.mutate()}
        >
          {createMutation.isPending ? "Vytvářím…" : "Vytvořit"}
        </button>
      </div>

      {isLoading && <p>Načítám…</p>}
      {data && (
        <table>
          <thead>
            <tr>
              <th>Název</th>
              <th>Popis</th>
              <th>Členů</th>
              <th>Vytvořeno</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((l) => (
              <tr key={l.id}>
                <td>{l.name}</td>
                <td className="muted">{l.description ?? "—"}</td>
                <td>{l.member_count}</td>
                <td className="muted">{new Date(l.created_at).toLocaleDateString("cs-CZ")}</td>
                <td>
                  <button
                    type="button"
                    className="secondary"
                    onClick={() => {
                      if (confirm(`Smazat seznam "${l.name}"?`)) deleteMutation.mutate(l.id);
                    }}
                  >
                    Smazat
                  </button>
                </td>
              </tr>
            ))}
            {data.items.length === 0 && (
              <tr>
                <td colSpan={5} className="muted" style={{ textAlign: "center" }}>
                  Zatím žádné seznamy
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
